import { styled } from '../../Utilities';
import { DetailsHeaderBase } from './DetailsHeader.base';
import { getDetailsHeaderStyles } from './DetailsHeader.styles';
export var DetailsHeader = styled(DetailsHeaderBase, getDetailsHeaderStyles, undefined, {
  scope: 'DetailsHeader'
});